import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"
import Button from "../../../shared/components/atoms/button/button"
import "./card-test.scss"

const CardTest = ({ onClickReference, descubreProductoIdeal, color }) => {
  const {
    cardDesktop: {
      childImageSharp: { fixed: imgCardProductoIdeal },
    },
    cardMobile: {
      childImageSharp: { fluid: imgCardMobile },
    },
  } = useStaticQuery(graphql`
    {
      cardDesktop: file(name: { eq: "card-producto-ideal" }) {
        childImageSharp {
          fixed(height: 256) {
            width
            height
            src
            srcSet
          }
        }
      }
      cardMobile: file(name: { eq: "card-producto-ideal-mobile" }) {
        childImageSharp {
          fluid(quality: 100) {
            aspectRatio
            src
            srcSet
            srcWebp
            srcSetWebp
            sizes
          }
        }
      }
    }
  `)

  return (
    <>
      <div className="f-card-test-desktop">
        <Img
          fixed={imgCardProductoIdeal}
          className="f-card-test__img"
          objectFit="contain"
        />
        <p className="f-card-test-desktop__description">
          {descubreProductoIdeal.descripcionProductoIdeal}
        </p>
        <Button
          className="f-card-test-desktop__btn new-dark-blue short"
          title={descubreProductoIdeal.ctaProductoIdeal}
          onClick={onClickReference}
        />
      </div>
      <button className="f-card-test-mobile" onClick={onClickReference}>
        <Img
          fluid={imgCardMobile}
          className="f-card-test__img"
          objectFit="contain"
        />
      </button>
    </>
  )
}

export default CardTest
